<template>
  <v-layout v-if="authStore.isLoggedIn" :dir="$root.$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :full-height="true"
    class="rounded rounded-md">

    <dashboard-sidebar v-model:drawer="drawer" />

    <dashboard-header v-model:drawer="drawer" />

    
    <v-main class="tw-min-h-screen tw-h-fit tw-overflow-y-auto tw-bg-gray-100">
      <!-- Order Reminder Banner -->
      <order-reminder-banner />
      <router-view></router-view>
    </v-main>
  </v-layout>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import DashboardHeader from "./partials/DashboardHeader.vue";
import DashboardSidebar from "./partials/DashboardSidebar.vue";
import OrderReminderBanner from "@/components/notifications/OrderReminderBanner.vue";
import { useAuthStore, useUserStore } from "@/stores";
import initial from "@/services/app/initial";
import { useI18n } from "vue-i18n";
import pusherService from "@/services/pusher";

const i18n = useI18n();
const drawer = ref(true);
const authStore = useAuthStore();
const userStore = useUserStore();
let onlineUsersChannel = null;

const { execute } = initial();

if (i18n.locale.value == 'ar') {
  document.querySelector('html').setAttribute('dir', 'rtl');
}

// get required data for the app
execute();

/**
 * Setup online users channel for presence
 */
const setupOnlineUsersChannel = () => {
  if (!authStore.user || !pusherService.isConnectedStatus()) {
    console.warn('Cannot setup online users channel: user not authenticated or pusher not connected');
    return;
  }

  try {
    const channelId = 1; // Using the same channel ID as before
    onlineUsersChannel = pusherService.joinChannel(`channel.${channelId}`);
    
    if (onlineUsersChannel) {
      onlineUsersChannel
        .here((members) => {
          console.log('Users currently online:', members);
          userStore.setOnline(members);
        })
        .joining((member) => {
          console.log('User joined:', member);
          userStore.online.push(member);
        })
        .leaving((member) => {
          console.log('User left:', member);
          userStore.setOnline(userStore.online.filter(m => m.name != member.name));
        });
    }
  } catch (error) {
    console.error('Error setting up online users channel:', error);
  }
};

/**
 * Cleanup online users channel
 */
const cleanupOnlineUsersChannel = () => {
  if (onlineUsersChannel) {
    try {
      const channelId = 1;
      pusherService.leaveChannel(`channel.${channelId}`);
      onlineUsersChannel = null;
    } catch (error) {
      console.error('Error cleaning up online users channel:', error);
    }
  }
};

// Setup when component mounts
onMounted(() => {
  // Wait a bit for auth to be initialized if needed
  setTimeout(() => {
    if (authStore.isLoggedIn && authStore.user) {
      setupOnlineUsersChannel();
    }
  }, 1000);
});

// Cleanup when component unmounts
onUnmounted(() => {
  cleanupOnlineUsersChannel();
});

</script>
